import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { generateCSVTemplate } from '@/lib/csvParser';

export function DownloadTemplateButton() {
  const { t } = useTranslation(['clients']);

  const handleDownload = () => {
    const content = generateCSVTemplate();
    const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'client_import_template.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="link" onClick={handleDownload} className="text-sm">
      <Download className="h-4 w-4 mr-2" />
      {t('import.downloadTemplate')}
    </Button>
  );
}
